import React from "react";
import typescript from "../../../../assets/img/programming/typescript.webp";
import BackBtn from "../../../../components/Button/BackBtn";
import { DataDoc } from "./DataTypescript";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: 100,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      delay: 0.4,
      duration: 0.4,
    },
  },
  exit: {
    x: " -100vw",
    transition: {
      ease: "easeInOut",
      delay: 0.4,
      duration: 0.4,
    },
  },
};

const Typescript = () => {
  return (
    <motion.section
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="blockPage"
    >
      <BackBtn />
      <div className="choice">
        <img className="iconTop" src={typescript} alt="" />
        <h2 className="titleTop"> Typescript </h2>
      </div>
      <h3 className="blockPage__title">Docs / Cheatsheet</h3>
      <div className="blockPage__content">
        {DataDoc.map((item, index) => {
          return (
            <ul key={index} className="blockPage__lists">
              <li className="blockPage__lists--item">
                <a
                  className="blockPage__lists--link"
                  href={item.path}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img className={item.cName} src={item.icon} alt="icone" />
                  <p className="blockPage__lists--title">{item.title}</p>
                </a>
                <p className="blockPage__lists--text"> {item.description} </p>
              </li>
            </ul>
          );
        })}
      </div>
    </motion.section>
  );
};

export default Typescript;
